export default class DOMHelpers {

    static scrollToMiddle(element) {
		if (element) {
			element.scrollIntoView({
				behavior: 'auto',
				block: 'center',
				inline: 'center',
				behavior: 'smooth'
			});
		}
    }

}
